import { css } from '@emotion/react';

import ButtonDownload from '~/common/components/ButtonDownload';
import { LAUNCHER_DOWNLOAD_URL } from '~/common/data/launcher.data';

export default function SectionDownload() {
  return (
    <section css={styles.wrapper}>
      <h2 css={styles.title}>원격 데스크톱, 지금 바로 시작</h2>
      <p css={styles.desc}>접속 프로그램을 설치하고 어디서든 내 데스크톱에 연결하세요.</p>

      <div css={styles.buttonRow}>
        <ButtonDownload
          label="Windows 다운로드"
          href={LAUNCHER_DOWNLOAD_URL}
          sublabel="원격 데스크톱 접속기"
        />
      </div>
    </section>
  );
}

const styles = {
  wrapper: css`
    width: 100%;
    padding: 120px 16px 140px;
    margin-top: 100px;
    text-align: center;
    background: rgba(255, 255, 255, 0.05);
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  `,

  title: css`
    font-size: 32px;
    font-weight: 800;
    margin-bottom: 12px;
    color: white;

    @media (min-width: 768px) {
      font-size: 40px;
    }
  `,

  desc: css`
    font-size: 16px;
    opacity: 0.75;
    margin-bottom: 56px;
    color: white;

    @media (min-width: 768px) {
      font-size: 18px;
    }
  `,

  buttonRow: css`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
  `,
};
